import React from 'react';
import { motion } from 'framer-motion';

const CuriositySection = () => {
  return (
    <section 
      id="curiosity" 
      className="h-screen w-full bg-black flex items-center justify-center px-4"
    >
      <div className="max-w-7xl mx-auto text-center">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-8"
        >
          <span 
            className="block text-[#A47F2D] font-light tracking-[0.15em] mb-6"
            style={{
              fontFamily: "'Reforma-1918', serif",
              fontWeight: 900,
              fontSize: 'clamp(11px, 4vw, 70px)',
              whiteSpace: 'nowrap',
            }}
          >
            TRANSFORMING CURIOSITY
          </span>
          <span 
            className="block text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl 2xl:text-9xl font-light tracking-[0.12em] leading-[0.95]"
            style={{ fontFamily: "'Reforma-1918', serif", fontWeight: 900 }}
          >
            CONNECTING
          </span>
          <span 
            className="block text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl 2xl:text-9xl font-light tracking-[0.12em] leading-[0.95]"
            style={{ fontFamily: "'Reforma-1918', serif", fontWeight: 900 }}
          >
            CULTURE
          </span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="text-white/80 text-base sm:text-lg md:text-xl lg:text-2xl font-light tracking-wide max-w-5xl mx-auto mb-12 leading-relaxed"
          style={{ fontFamily: "'Reforma 1918 Blanca', Regular" }}
        >
          Rooted in Africa's timeless traditions of<br />
          Design, Art, Architecture and Technology
        </motion.p>

        <motion.button
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.5 }}
          className="px-8 py-3 text-xs sm:text-sm font-light text-white border border-white/80 rounded-full tracking-[0.2em] hover:text-[#A47F2D] hover:border-[#A47F2D] transition-all duration-300 hover:scale-105"
          style={{ fontFamily: "'Reforma-1918', serif" }}
        >
          STEP INTO THE VISION
        </motion.button>
      </div>
    </section>
  );
};

export default CuriositySection;